import styled from '@emotion/styled';
import pym from 'pym.js';
import React, { useState, useEffect } from 'react';

import EstimationForHomeOwner from './EstimationForHomeOwner/Index';
import QuotingWidgetForm from './QuotingWidgetForm';
import { logGetStarted } from './analytics';
import { withFeatureFlagsProvider } from '../../FeatureFlag';
import FeatureFlagged from '../../FeatureFlag/FeatureFlagged';

// Analytics

// Components

// Assets
const launchImgUrl =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/c_crop,h_900,w_1438,x_0,y_0/f_auto,q_auto/f_auto/v1/pagebuilder/uploads/prod/11077825/trudefduration1';
const PPURL =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1679342799/roofing/quoting-widget/PP-Presenting-open-eyes.png';
const logoURL = 'https://imagecdn.owenscorning.com/ocimages/image/upload/v1575575892/meganav/oc-logo.svg';

// Styled Components
const WidgetContainer = styled.div`
  background-color: #f8f8f8;
  display: block;
  margin: 0 auto;
  max-width: 900px;
  position: relative;
  width: 100%;
`;

const WidgetPage = styled.div`
  display: ${props => (props.active ? 'inline-flex' : 'none')};
  position: relative;
  width: 100%;
`;

const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  width: 342px;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

const WelcomeImage = styled.img`
  display: none;
  flex-shrink: 0;
  left: -418px;
  max-height: 100%;
  position: absolute;
  width: auto;

  @media screen and (min-width: 768px) {
    display: inline-block;
  }
`;

const TechnologyBanner = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  position: relative;
  top: 78%;
  width: 100%;
`;

const PPImage = styled.img`
  height: 55px;
  padding-right: 6px;
  width: 58px;
`;

const LogoImage = styled.img`
  height: 36px;
  width: 36px;
`;

const LogoWrapper = styled.div`
  align-items: flex-end;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  left: 218px;
  padding: 8px 16px;
`;

const ImageTextWrapper = styled.div`
  align-items: flex-end;
  background-color: #ffffff;
  color: #000000;
  display: flex;
  flex-direction: column;
  font-family: 'Oswald';
  font-size: 16px;
  line-height: 18px;
  padding: 8px 16px;
  text-transform: uppercase;
`;

const PinkText = styled.span`
  color: #d40f7d;
`;

const QuotingWidget = props => {
  const userPrefilledPostal = props?.prefilledData?.contact?.postalCode;
  const { estimateId } = props;
  const [showStartPage, setShowStartPage] = useState(true);
  const [clientZipCode, setClientZipCode] = useState(userPrefilledPostal);
  const [openModal, setOpenModal] = useState();

  let scrollPosition = 0;

  const validServiceArea = value => (_.isEmpty(props.serviceArea) ? true : props.serviceArea.includes(value));

  const setClientZipCodeFromIp = () => {
    fetch('https://ipapi.co/json/')
      .then(response => response.json())
      .then(responseJSON => {
        setClientZipCode(responseJSON.postal);
      });
  };

  useEffect(() => {
    if (!clientZipCode) {
      setClientZipCodeFromIp();
    } else {
      setOpenModal(!validServiceArea(clientZipCode));
    }
  }, [clientZipCode]);

  useEffect(() => {
    const pymChild = pym.Child({ polling: 100 });
    pymChild.sendMessage('height');
    pymChild.onMessage('parentScrollPosition', args => {
      const data = JSON.parse(args);
      const modal = document.querySelector('[data-structure="modal-body"]');

      if (modal) {
        if (data.top > data.iframeTop) {
          scrollPosition = data.top - data.iframeTop;
          modal.style.top = `${scrollPosition}px`;
        } else {
          modal.style.top = 0;
        }
      }
    });
    logGetStarted();

    return () => {
      pymChild.remove();
    };
  }, []);

  const toggleImage = () => {
    setShowStartPage(!showStartPage);
  };

  if (!props.configuration || !props.configuration.active) {
    return null;
  }

  return (
    <WidgetContainer>
      {estimateId && (
        <WidgetPage active>
          <EstimationForHomeOwner
            configuration={props.configuration}
            contractorAddress={props.contractorAddress}
            estimateId={estimateId}
          />
        </WidgetPage>
      )}

      {!estimateId && (
        <WidgetPage active>
          <QuotingWidgetForm
            clientZipCode={clientZipCode}
            toggleImage={toggleImage}
            showStartPage={showStartPage}
            {...props}
          />
          {showStartPage && (
            <ImageWrapper>
              <WelcomeImage src={launchImgUrl} alt="Close-up of house with roof visible" />
              <TechnologyBanner>
                <LogoWrapper>
                  <PPImage src={PPURL} alt="Pink Panther Open Eyes" />
                  <LogoImage src={logoURL} alt="Owens Corning Logo" />
                </LogoWrapper>
                <ImageTextWrapper>
                  <span>Technology Powered</span>
                  <span>
                    By <PinkText>Owens Corning</PinkText>
                  </span>
                </ImageTextWrapper>
              </TechnologyBanner>
            </ImageWrapper>
          )}
        </WidgetPage>
      )}
    </WidgetContainer>
  );
};

export default withFeatureFlagsProvider(QuotingWidget);
